import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {flightTrackerPagesEdit_template} from "../components/templates/flightTrackerPagesEdit_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class flight_tracker_page_edit extends vnModule_knockoutJS {

    protected flightTrackerPagesEdit: flightTrackerPagesEdit_template
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Array<Element> {
        this.flightTrackerPagesEdit = new flightTrackerPagesEdit_template('flight_tracker_page_edit_template', this.viewModel, this)
        return [this.flightTrackerPagesEdit.build()]
    }

    protected getModuleName(): string {
        return "flight_tracker_page_edit";
    }

    public fillPage() {
        this.getDataForEdit()
    }

    public getIdBrand(): number {
        return this.getVnAppZone().app.params.idBrand;
    }

    private getDataForEdit() {
        this.loadingIn(this.flightTrackerPagesEdit.builtTemplate);

        if (this.getVnAppZone().app.params.hasOwnProperty('id')) {
            this.flightTrackerPagesEdit.setContextApp("Edit Flight Tracker Page");
            this.flightTrackerPagesEdit.isEditionMode(true);
        } else {
            this.flightTrackerPagesEdit.setContextApp("Add New Flight Tracker Page");
            this.flightTrackerPagesEdit.isEditionMode(false);
        }

        let url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/flight-tracker-pages/get/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetDataForEdit;
        this.XHRHdl.execute();
    }

    private onGetDataForEdit(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.defaultThreshold) {
                    obj.flightTrackerPagesEdit.setDefaultThreshold(responseParsed.defaultThreshold);
                }
                obj.flightTrackerPagesEdit.setData(responseParsed.data);
            });
            obj.loadingOut(obj.flightTrackerPagesEdit.builtTemplate);
        }
    }

    public viewOnWebsite(permalink: string) {
        let idBrand = this.getVnAppZone().app.params.idBrand;
        let userBrands = this.getVnAppZone().app.loggedUser.user.brands;
        let url = window.location.hostname.split(".");
        let urlBegin = "https://";
        let isLocal = false;

        if (url.length == 3) {
            if (url[0] != "emakicms") {
                // QA override: the flight-tracker site feature is deployed on qa5,
                // while emaki runs on qa2. Remap so links target qa5.simpleflying.com.
                let subdomain = url[0] === "qa2" ? "qa5" : url[0];
                urlBegin += subdomain + ".";
            } else {
                isLocal = true;
            }
        }

        for (let i = 0; i < userBrands.length; i++) {
            if (userBrands[i].id == idBrand) {
                window.open(urlBegin + userBrands[i].domain.replace("www.", "") + (isLocal ? ("." + url[2]) : "") + permalink, "_blank")
                break;
            }
        }
    }

    public onClickCancelEdit() {
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/config/flight-tracker-pages/")
    }

    public cancelForm() {
        this.onClickCancelEdit();
    }

    protected save() {
        this.loadingIn(this.flightTrackerPagesEdit.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + "/flight-tracker-pages/save/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {
            return function () {
                obj.manageResponse(req, obj, function () {
                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Flight tracker page saved !");
                    }
                    page.redirect('/brand/' + idBrand + "/config/flight-tracker-pages/");
                });
                obj.loadingOut(obj.flightTrackerPagesEdit.builtTemplate);
            }
        });
        XHRHdl.execute();
    }
}



// WEBPACK FOOTER //
// ./js/modules/flight_tracker_page_edit.ts